import {http} from '@/utils/request';

/**
 * 获取提现金额选项
 * @param useType - 使用类型：1=UPI, 2=CRYPTO
 * @returns Promise<number[]> 返回金额选项数组
 */
export const getWithdrawAmountOptions = async (
  useType?: number,
): Promise<number[]> => {
  const response = await http.post<{useType?: number}, number[]>(
    '/app/pay/withdrawal/amounts',
    {useType},
  );
  return response;
};
